export default __webpack_public_path__ + "static/media/fastlane.c0d703a3.svg";